(function ($) {
  if (window.BoyaProductRecommend) return;
  window.BoyaProductRecommend = { bound: true };

  function syncRecommendBtn($root) {
    var $btn = $root.find('[data-recommend-btn]');
    if (!$btn.length) return;

    var ready =
      $root.find('[data-q="1"] .is-active').length > 0 &&
      $root.find('[data-q="2"] .is-active').length > 0 &&
      $root.find('[data-q="3"] .is-active').length > 0;

    $btn.toggleClass('disabled', !ready).prop('disabled', !ready);

    if (!ready) showResult($root, 'default');
  }

  function showResult($root, key) {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var bg = isMobile
      ? ($root.attr('data-bg-' + key + '-mobile') || $root.attr('data-bg-default-mobile') || $root.attr('data-bg-' + key) || $root.attr('data-bg-default'))
      : ($root.attr('data-bg-' + key) || $root.attr('data-bg-default'));
    $root.css('background-image', bg ? 'url("' + bg + '")' : '');
    $root.toggleClass('is-default', key === 'default');
    $root.find('[data-result-panel]').removeClass('is-active');
    $root.find('[data-result-panel="' + key + '"]').addClass('is-active');
  }

  $(document).on('click', '[data-product-recommend] [data-option-item]', function () {
    var $item = $(this);
    var $root = $item.closest('[data-product-recommend]');
    $item.toggleClass('is-active').attr('aria-pressed', $item.hasClass('is-active'));
    syncRecommendBtn($root);
  });

  $(document).on('click', '[data-product-recommend] [data-choice-item]', function () {
    var $item = $(this);
    var $root = $item.closest('[data-product-recommend]');
    var $group = $item.closest('[role="radiogroup"]');

    $group.find('[data-choice-item]').removeClass('is-active').attr('aria-checked', 'false');
    $item.addClass('is-active').attr('aria-checked', 'true');
    syncRecommendBtn($root);
  });

  $(document).on('click', '[data-product-recommend] [data-recommend-btn]', function () {
    var $btn = $(this);
    if ($btn.prop('disabled')) return;

    var $root = $btn.closest('[data-product-recommend]');
    var key = $root.find('[data-q="3"] .is-active').attr('data-choice') || 'a';
    showResult($root, key);
  });
})(jQuery);
